import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import LocationTable from './components/LocationTable';
import toast from 'react-hot-toast';
import { createAPIEndPoint } from 'config/api/api';
import Loader from 'loaders/Loader';
import { logoutUser } from 'utils';
import { useNavigate } from 'react-router-dom';
import { getUserData } from 'utils';

const Location = () => {
  const navigate = useNavigate();
  const userData = getUserData();
  const clinic_id = userData?.clinic_id ?? null;
  const [locationsData, setLocationsData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLocations = async () => {
    setLoading(true);
    try {
      const response = await createAPIEndPoint(
        `clinic_locations/get_all/${clinic_id}`,
      ).fetchFiltered({ get_all: true });
      setLocationsData(response.data.locations || []);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Error fetching locations');
      if (err?.response?.data?.error?.includes('Bearer token')) {
        logoutUser(navigate);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (clinic_id) {
      fetchLocations();
    }
  }, [clinic_id]);

  return (
    <Box pt={{ base: '80px', md: '80px', xl: '80px' }}>
      {loading && <Loader />}
      <LocationTable
        tableData={locationsData}
        loading={loading}
        fetchAgain={fetchLocations}
      />{' '}
    </Box>
  );
};

export default Location;
